// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ptrendEntity from './entities/ptrend.json';
import ptrendMenu from '../pages/ptrend/menu.json';
import ptrendFullForm from '../pages/ptrend/forms/full.json';
import ptrendContextForm from '../pages/ptrend/forms/context.json';
import ptrendMiniForm from '../pages/ptrend/forms/mini.json';
import ptrendLookupForm from '../pages/ptrend/forms/lookup.json';
import ptrendTableView from '../pages/ptrend/views/table.json';
import ptrendStagesView from '../pages/ptrend/views/stages.json';
import ptrendCardsView from '../pages/ptrend/views/cards.json';
import ptrendInlineView from '../pages/ptrend/views/inline.json';
import ptrendBacklogView from '../pages/ptrend/views/backlog.json';
import ptrendSplitView from '../pages/ptrend/views/split.json';
import ptrendCalendarView from '../pages/ptrend/views/calendar.json';
import ptrendDashboardView from '../pages/ptrend/views/dashboard.json';

/** Тип запису «Тенденція» зі сторінками пакета: меню, форми та подання з pages/ptrend/. */
export const ptrendDefinition: IRecordTypeDefinition = {
  ...ptrendEntity,
  views: assembleViewSet({
      table: ptrendTableView,
      stages: ptrendStagesView,
      cards: ptrendCardsView,
      inline: ptrendInlineView,
      backlog: ptrendBacklogView,
      split: ptrendSplitView,
      calendar: ptrendCalendarView,
      dashboard: ptrendDashboardView,
  }),
  form: ptrendFullForm,
  forms: { full: ptrendFullForm, context: ptrendContextForm, mini: ptrendMiniForm, lookup: ptrendLookupForm },
  menu: ptrendMenu,
} as IRecordTypeDefinition;
